import { render, staticRenderFns } from "./reportNotificationcount.vue?vue&type=template&id=af702496"
import script from "./reportNotificationcount.vue?vue&type=script&lang=js"
export * from "./reportNotificationcount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports